import { render, staticRenderFns } from "./purchaseTicketLog.vue?vue&type=template&id=5901f66a&"
import script from "./purchaseTicketLog.vue?vue&type=script&lang=js&"
export * from "./purchaseTicketLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports